import { TenderUpdateExtensionsRequest } from '@Types/api/form/tenderRequest/TenderUpdateExtensionsRequest';
import { TypeDict } from '@Types/index';

export interface TenderExtensionForm {
  extensionType: string;
  extensionId: string;
  extensionAttachment: string | null;
}

export const mapTenderExtensionUpdateForm = (
  formData: TenderExtensionForm,
  tenderExtensionTypeDict: TypeDict[]
): Omit<
  TenderUpdateExtensionsRequest,
  'compId' | 'tenderId' | 'extensionAttachment'
> => {
  const extensionTypeId = tenderExtensionTypeDict.find(
    (dictItem) => dictItem.codeDesc === formData.extensionType
  )!.codeNum;

  return {
    extensionTypeId,
    extensionId: formData.extensionId,
  };
};
